import { useProfile } from "@/context/useProfileProps";
import { useMobile } from "@/hooks";
import { Button, Modal } from "@monsterindia/global-ui-components";
import React from "react";

import "./resources/AutoApply.scss";

type DisclaimerModalProps = {
  isOpenModal: boolean;
  setIsOpenModal: (value: boolean) => void;
  handleDisable: () => void;
};

export default function DisclaimerModal({
  isOpenModal,
  setIsOpenModal = () => {},
  handleDisable,
}: DisclaimerModalProps) {
  const isMobile = useMobile();

  const handleEnable = () => {
    setIsOpenModal(false);
  };

  return (
    <Modal
      screenAlignment={isMobile ? "bottom-sheet" : "center"}
      showHandleBar={isMobile}
      showModal={isOpenModal}
      closeModal={() => setIsOpenModal(false)}
      showCloseButton={true}
      customClass="!px-0 !py-2 !h-max"
    >
      <div className="modalContainerTop">
        <div className="modalContainerTop__heading">
          Turn off AI auto-apply?
        </div>

        <p>
          AI Auto Apply helps you apply to relevant jobs automatically, so you
          don’t have to keep searching and applying yourself. Keep it on and let
          foundit apply for you.
        </p>
      </div>

      <div className="modalContainerBottom">
        <Button
          onClick={handleDisable}
          label="Turn Off"
          modifier="secondary"
          size="lg"
          className="modalContainerBottom__enable"
        />

        <Button
          onClick={handleEnable}
          label="Keep it Enabled"
          modifier="primary"
          size="lg"
          className="modalContainerBottom__disable"
        />
      </div>
    </Modal>
  );
}
